import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsSearchOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { name: '首页', path: '/' },
    { name: '电影', path: '/category/action' },
    { name: '电视剧', path: '/category/tv' },
    { name: '综艺', path: '/category/variety' },
    { name: '动漫', path: '/category/animation' },
    { name: '关于我们', path: '/about' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-[0_2px_20px_rgba(0,0,0,0.3)]'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <span className="font-heading text-2xl md:text-3xl font-bold text-primary-500 tracking-wider">
              7777<span className="text-foreground-50">影院</span>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-200 whitespace-nowrap ${
                  location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-500'
                    : 'text-foreground-300 hover:text-primary-400'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            {isSearchOpen ? (
              <div className="flex items-center gap-2 animate-[fadeIn_0.2s_ease]">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索电影、电视剧..."
                  className="w-48 md:w-64 bg-background-100 border border-background-300/60 rounded-full px-4 py-2 text-sm text-foreground-50 placeholder:text-foreground-600 focus:outline-none focus:border-primary-500/50 transition-colors"
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                      setIsSearchOpen(false);
                      setSearchQuery('');
                    }
                  }}
                />
                <button
                  onClick={() => {
                    setIsSearchOpen(false);
                    setSearchQuery('');
                  }}
                  className="w-8 h-8 flex items-center justify-center text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer"
                  aria-label="关闭搜索"
                >
                  <i className="ri-close-line text-lg"></i>
                </button>
              </div>
            ) : (
              <button
                onClick={() => setIsSearchOpen(true)}
                className="w-9 h-9 flex items-center justify-center text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
            )}

            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </nav>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/50 animate-[fadeIn_0.2s_ease]">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                  location.pathname === link.path || (link.path !== '/' && location.pathname.startsWith(link.path))
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-300 hover:text-primary-400 hover:bg-background-100'
                }`}
              >
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}